module.exports = __webpack_public_path__ + "static/thumbnail-banner.2bcf45db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-banner.jpg
// module id = 266
// module chunks = 35783957827783 114276838955818